// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '../static/css/common.css'
import router from './router/index'
import store from './store'
import VDistpicker from 'v-distpicker'



import md5 from 'js-md5';
import moment from 'moment'

import {getRequest} from './api/http'
import {postRequest} from './api/http'
import {deleteRequest} from './api/http'
import {putRequest} from './api/http'
import {uploadFileRequest} from './api/http'
import {downFileRequest} from './api/http'
import allFn from '../src/global/global'
import base from './api/baseUrl'
import '../static/js/rem'

Vue.component('v-distpicker', VDistpicker);


Vue.config.productionTip = false;
Vue.prototype.$md5 = md5;


Vue.use(ElementUI);
Vue.prototype.getRequest = getRequest;
Vue.prototype.postRequest = postRequest;
Vue.prototype.deleteRequest = deleteRequest;
Vue.prototype.putRequest = putRequest;
Vue.prototype.uploadFileRequest = uploadFileRequest;
Vue.prototype.downFileRequest = downFileRequest;
Vue.prototype.$moment = moment;
Vue.prototype.$allFn = allFn;
Vue.prototype.$baseUrl = base;


window.addEventListener('popstate', function() {
  history.pushState(null, null, document.URL)
})

Vue.filter('datefmt', function (input, fmtstring) {
  return moment.unix(input).format(fmtstring)
})
Vue.directive('focus', {
  bind: function (el) { 
    // el.focus()
  },
  inserted: function (el) {  // inserted 表示元素插入到DOM中的时候，会执行 inserted 函数【触发1次】
    el.focus()
    // 和JS行为有关的操作，最好在 inserted 中去执行，放置 JS行为不生效
  },
  updated: function (el) {  // 当VNode更新的时候，会执行 updated，可能会触发多次

  }
})

Vue.prototype.$textLength = function (contentLength,num) {
  if(contentLength == num) {
        this.$message({
          message: '不能超过' + contentLength +'个字',
          type: 'warning'
       });
  }
};

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js